import { render, staticRenderFns } from "./ImpressaoAtividades.vue?vue&type=template&id=32002000"
import script from "./ImpressaoAtividades.vue?vue&type=script&lang=js"
export * from "./ImpressaoAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports